import { jsPDF } from 'jspdf';

export type CertificadoPdfInput = {
  titulo: string;
  aluno_nome: string;
  emitido_em: string;
  codigo: string;
  programa_titulo?: string | null;
  /** Certificação de conselheiro: vale até esta data. */
  valido_ate?: string | null;
};

export function downloadCertificadoPdf(data: CertificadoPdfInput): void {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const W = 297;
  const H = 210;
  const M = 22;
  const AM: [number, number, number] = [255, 200, 0];
  const DK: [number, number, number] = [12, 12, 14];
  const CZ: [number, number, number] = [120, 120, 125];

  doc.setFillColor(DK[0], DK[1], DK[2]);
  doc.rect(0, 0, W, H, 'F');

  doc.setDrawColor(AM[0], AM[1], AM[2]);
  doc.setLineWidth(0.8);
  doc.rect(M, M, W - M * 2, H - M * 2, 'S');
  doc.setLineWidth(0.25);
  doc.rect(M + 4, M + 4, W - M * 2 - 8, H - M * 2 - 8, 'S');

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(CZ[0], CZ[1], CZ[2]);
  doc.text('HACK ACADEMY · ESCOLA DE NEGÓCIOS', W / 2, M + 14, { align: 'center' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(28);
  doc.setTextColor(AM[0], AM[1], AM[2]);
  doc.text('Certificado', W / 2, M + 32, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  doc.setTextColor(230, 230, 232);
  doc.text('Certificamos que', W / 2, M + 48, { align: 'center' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(20);
  doc.setTextColor(255, 255, 255);
  doc.text(data.aluno_nome, W / 2, M + 62, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  doc.setTextColor(230, 230, 232);
  doc.text(data.valido_ate ? 'foi aprovado na certificação' : 'concluiu com êxito', W / 2, M + 74, { align: 'center' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.setTextColor(AM[0], AM[1], AM[2]);
  const tituloLines = doc.splitTextToSize(data.titulo, W - M * 2 - 40);
  doc.text(tituloLines, W / 2, M + 88, { align: 'center' });

  if (data.programa_titulo) {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(CZ[0], CZ[1], CZ[2]);
    doc.text(`Programa: ${data.programa_titulo}`, W / 2, M + 100, { align: 'center' });
  }

  const emitido = new Date(data.emitido_em).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(CZ[0], CZ[1], CZ[2]);
  const validade = data.valido_ate
    ? ` · válido até ${new Date(data.valido_ate).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })}`
    : '';
  doc.text(`Emitido em ${emitido}${validade}`, W / 2, H - M - 22, { align: 'center' });

  doc.setFont('courier', 'normal');
  doc.setFontSize(8);
  doc.text(`Código de validação: ${data.codigo}`, W / 2, H - M - 12, { align: 'center' });
  doc.text('academy.hack.net.br/certificado/', W / 2, H - M - 6, { align: 'center' });

  const safeName = data.aluno_nome.replace(/\s+/g, '-').slice(0, 40);
  doc.save(`certificado-hackacademy-${safeName}-${data.codigo.slice(0, 8)}.pdf`);
}
